<template>
  <div>
    <iframe width="100%" height="1000px" :src="opportunityMapUrl"
            frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as accountTypes from '@/modules/account/store/types'

export default
{
  computed:{
    ...mapGetters({
      user: accountTypes.USER
    }),
    opportunityMapUrl(){
      if(this.user.opportunity_map_data_studio_link){
        return this.user.opportunity_map_data_studio_link
      }else{
        return `https://lookerstudio.google.com/embed/reporting/8cf6c8f6-aa52-4cc9-ba4c-c00b70a49738/page/p_n5rn5t2t0c/edit?params=%7B"df40":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.user.appify_consultant_id}"%7D`
      }
    }
  }
}
</script>
